import { generateTestId } from "@client-shared";

export const setShopifyConnectModalTestId = (identifier: string): string => generateTestId("ShopifyConnectModal", identifier);
